import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const options = {
  icon: (icon = ['fas', 'stroopwafel'], text) => {
    const iconElement = <FontAwesomeIcon icon={icon} />;

    if (!text) return iconElement;
    return (
      <span>
        {iconElement}
        {text}
      </span>
    );
  },
};

const dev = (option = null, params = []) => {
  const { location } = window;
  const { hostname, port } = location;

  const userIsDev = hostname === 'localhost' && [8080, 8081].includes(+port);

  if (!userIsDev) return false;

  if (option === null) return userIsDev;

  if (!Object.keys(options).includes(option)) return options.icon(...[undefined, option, ...params]);

  if (option !== null) return options[option](...params);

  return false;
};

export default dev;
